import { render, staticRenderFns } from "./index_bak.vue?vue&type=template&id=368b1d40&scoped=true"
import script from "./index_bak.vue?vue&type=script&lang=js"
export * from "./index_bak.vue?vue&type=script&lang=js"
import style0 from "./index_bak.vue?vue&type=style&index=0&id=368b1d40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368b1d40",
  null
  
)

export default component.exports